module.exports = "/favicon.png?A4HSk15";